import { render, staticRenderFns } from "./ButtonChoice.vue?vue&type=template&id=9a4f3032&scoped=true"
import script from "./ButtonChoice.vue?vue&type=script&lang=js"
export * from "./ButtonChoice.vue?vue&type=script&lang=js"
import style0 from "./ButtonChoice.vue?vue&type=style&index=0&id=9a4f3032&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a4f3032",
  null
  
)

export default component.exports